import { combineReducers } from '@reduxjs/toolkit';

// Export all speaking slice modules
// Import individual slice reducers
import speakingChildReducer, { SpeakingState } from './speakingSlice';
import sessionsReducer, { SessionsState } from './sessionsSlice';
import phonemesReducer, { PhonemesState } from './phonemesSlice';
import analyticsReducer, { AnalyticsState } from './analyticsSlice';
import practiceReducer, { PracticeState } from './practiceSlice';

// Export all actions from individual slices
export * from './speakingSlice';
export * from './sessionsSlice';
export * from './phonemesSlice';
export * from './analyticsSlice';
export * from './practiceSlice';

// Export state interfaces
export type {
    SpeakingState,
    SessionsState,
    PhonemesState,
    AnalyticsState,
    PracticeState,
};

// Export reducers

const speakingReducer = combineReducers({
    speaking: speakingChildReducer,
    sessions: sessionsReducer,
    phonemes: phonemesReducer,
    analytics: analyticsReducer,
    practice: practiceReducer,
});

export default speakingReducer;
